import React from "react";
import TemplatePreview from "./TemplatePreview";
import WhatsappTemplateEditorModal from "./WhatsappTemplateEditorModal";

// WhatsApp message — plain text, not sanitized HTML like the email template's
// `description`, since WhatsApp templates are never rich text.
const renderBody = (template) => (
  <div className="tpv-body tpv-body-whatsapp">{template.message}</div>
);

// Same list + detail preview as the email templates (see TemplatePreview.js).
function WhatsappTemplate() {
  return (
    <TemplatePreview
      fetchPath="getWhatsappTemplate"
      deletePath="deleteWhatsappTemplate"
      headlineLabel="Course"
      getHeadline={(t) => t.course}
      bodyLabel="Message"
      noun="WhatsApp"
      renderBody={renderBody}
      Editor={WhatsappTemplateEditorModal}
    />
  );
}

export default WhatsappTemplate;
